module.exports = __webpack_public_path__ + "img/07.a3a1d4b1.jpg";